// import node module libraries
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';
import SalledeclasseProfileLayout from './SalledeclasseProfileLayout';
import PrintInvoiceDetailsListeEleves from './PrintInvoiceDetailsListeEleves';

const InvoiceDetailsListeEleves = () => {
	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content: () => componentRef.current
	});

	return (
		<SalledeclasseProfileLayout>
			<Card className="w-100">
				<Link
					to="#"
					className="text-muted print-link no-print text-end me-5 mt-3 w-auto"
					onClick={handlePrint}
				>
					<i className="fa-solid fa-print"></i>
				</Link>
				<PrintInvoiceDetailsListeEleves ref={componentRef} />
			</Card>
		</SalledeclasseProfileLayout>
	);
};

export default InvoiceDetailsListeEleves;
